module.exports = false;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_library.js
// module id = 85
// module chunks = 17